import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
import psHttp from '@patsnap/common-ps-http';
export function updateShareApi(data) {
    const { space_id, folder_id, add_permissions, view_type } = data;
    const share_type = folder_id ? 'FOLDER' : 'SPACE';
    const share_ids = folder_id ? [folder_id] : [space_id];
    const _add_permissions = add_permissions?.map((item) => {
        return {
            ...item,
            user_role: item.user_role.toLocaleLowerCase(),
        };
    });
    return psHttp({
        url: `${workspaceApiUrlPrefix}/${space_id}/multi-share`,
        method: 'POST',
        data: {
            share_type,
            view_type,
            share_ids,
            add_permissions: _add_permissions,
        },
    }).then(({ data }) => {
        return Promise.resolve(true) || Promise.reject(data);
    });
}
export function getMembersInGroupApi(groupId, page, limit = 10) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/group/${groupId}/member`,
        method: 'GET',
        transformCode: true,
        params: {
            page,
            limit,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}
